import type {
  RealtimeStats,
  StatisticsReport,
  HourlyUsageData,
  ZoneOccupancyData,
  RevenueTrendData,
} from '../models';

/**
 * 통계 데이터 변환 서비스
 * 차트 데이터 포맷 변환 로직을 담당
 */
export class StatisticsService {
  /**
   * 시간대별 사용량 차트 데이터 변환
   */
  getHourlyUsageData(dailyReport: StatisticsReport | null): HourlyUsageData[] {
    if (!dailyReport?.peak_hours?.hourly_usage) {
      return [];
    }

    return Object.entries(dailyReport.peak_hours.hourly_usage).map(
      ([hour, count]) => ({
        hour: `${hour}시`,
        usage: count as number,
      })
    );
  }

  /**
   * 구역별 점유율 차트 데이터 변환
   */
  getZoneOccupancyData(realtimeStats: RealtimeStats | null): ZoneOccupancyData[] {
    if (!realtimeStats?.active_zones) {
      return [];
    }

    return Object.entries(realtimeStats.active_zones).map(([zone, count]) => ({
      name: zone,
      value: count,
    }));
  }

  /**
   * 수익 추이 차트 데이터 변환
   */
  getRevenueTrendData(weeklyReport: StatisticsReport | null): RevenueTrendData[] {
    if (!weeklyReport?.revenue?.revenue_by_day) {
      return [];
    }

    return Object.entries(weeklyReport.revenue.revenue_by_day).map(
      ([day, revenue]) => ({
        day,
        revenue: revenue as number,
      })
    );
  }
}

// 싱글톤 인스턴스
export const statisticsService = new StatisticsService();
